const SESSION_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
const OIDC_TRANSACTION_PATTERN = /^[A-Za-z0-9:._-]{1,4096}$/
const submittingSessions = new Set()


export function browserSessionIdFromQuery(query) {
  const value = query?.browser_session
  return typeof value === 'string' && SESSION_ID_PATTERN.test(value) ? value : ''
}


export function oidcTransactionFromQuery(query) {
  const value = query?.oidc_transaction
  return typeof value === 'string' && OIDC_TRANSACTION_PATTERN.test(value) ? value : ''
}


export function browserSessionEndpoint(apiBaseUrl, browserSession, action = '') {
  const suffix = action ? `${action}/` : ''
  return `${apiBaseUrl.replace(/\/$/, '')}/auth/browser-session/${browserSession}/${suffix}`
}


export function browserLoginFields({ browserSession, oidcTransaction, redirect, loginMethod, email, password, code }) {
  const fields = {
    browser_session: browserSession,
    login_method: loginMethod,
    email: email.trim()
  }
  if (oidcTransaction) fields.oidc_transaction = oidcTransaction
  if (redirect) fields.redirect = redirect
  if (loginMethod === 'code') fields.code = code
  else fields.password = password
  return fields
}


export function startBrowserSessionHeartbeat({ apiBaseUrl, browserSession, fetchImpl = fetch }) {
  if (!browserSession) return () => {}
  const heartbeat = () => {
    fetchImpl(browserSessionEndpoint(apiBaseUrl, browserSession, 'heartbeat'), {
      method: 'POST',
      credentials: 'include'
    }).catch(() => {})
  }
  heartbeat()
  const timer = setInterval(heartbeat, 30000)
  return () => clearInterval(timer)
}


export function cancelBrowserSession({ apiBaseUrl, browserSession, navigatorRef = navigator }) {
  if (!browserSession || submittingSessions.has(browserSession)) return
  const url = browserSessionEndpoint(apiBaseUrl, browserSession, 'cancel')
  if (typeof navigatorRef.sendBeacon === 'function') navigatorRef.sendBeacon(url)
}


export function submitBrowserSessionLogin({ apiBaseUrl, fields, documentRef = document }) {
  if (fields.browser_session) submittingSessions.add(fields.browser_session)
  const form = documentRef.createElement('form')
  form.method = 'post'
  form.action = `${apiBaseUrl.replace(/\/$/, '')}/auth/browser-login/`
  Object.entries(fields).forEach(([name, value]) => {
    const input = documentRef.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  })
  documentRef.body.appendChild(form)
  form.submit()
}
